import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import {useLocation} from "react-router";
import {UploadFeedback} from "../file/UploadFeedback";

export const Content = ({children}) => {
    const location = useLocation();
    const isLanding = location.pathname === "/";

    return (
        <Box
            component="main"
            id="main-content"
            sx={{
                flexGrow: 1,
                minWidth: 0,
                width: "100%",
                maxWidth: "100%",
                overflowX: "clip",
                display: "flex",
                flexDirection: "column",
            }}
        >
            {isLanding ? (
                children
            ) : (
                <Container
                    sx={{
                        flexGrow: 1,
                        minWidth: 0,
                        pt: {
                            xs: 2,
                            md: 3,
                        },
                        pb: 6,
                        px: {xs: 2, sm: 3},
                        maxWidth: "100%",
                        boxSizing: "border-box",
                    }}
                    maxWidth="xl"
                >
                    {children}
                </Container>
            )}
            <UploadFeedback />
        </Box>
    );
};